export default class Bounds {
	left: number
	right: number
	top: number
	bottom: number

	constructor (left: number, right: number, top: number, bottom: number) {
		this.left = left;
		this.right = right;
		this.top = top;
		this.bottom = bottom;
	}

	get width () {
		return this.right - this.left;
	}

	get height () {
		return this.bottom - this.top;
	}

	get area () {
		return (this.right - this.left) * (this.bottom - this.top);
	}

	toString () {
		return '[' + this.left + ',' + this.right + ']x[' + this.top + ',' + this.bottom + ']';
	}
}
